/* The pager's layout follows its own card's width, not the window's (APP-135). */
.wrap {
  container-type: inline-size;
  padding-top: 16px;
  border-top: 1px solid var(--border-card);
}

.pager {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-template-areas: 'info pages jump';
  align-items: center;
  gap: 12px 24px;
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--text-body);
}

.info {
  grid-area: info;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 24px;
  min-width: 0;
}

.count {
  margin: 0;
  color: var(--text-secondary);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.count strong {
  color: var(--text-heading);
  font-weight: 600;
}

.size {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--text-secondary);
  font-size: 13px;
  white-space: nowrap;
}

.select {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 84px;
  min-height: 44px;
  padding: 0 10px 0 12px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  background: var(--white);
  color: var(--text-body);
  font-family: var(--font-body);
  font-size: 15px;
  cursor: pointer;
}

.select[data-focus-visible],
.select[data-pressed] {
  outline: none;
  border-color: var(--brand-cyan);
  box-shadow: var(--focus-halo);
}

.select[data-disabled] {
  opacity: 0.55;
  cursor: not-allowed;
}

.pages {
  grid-area: pages;
  justify-self: center;
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 44px;
  padding: 0 6px;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--brand-navy);
  font-family: var(--font-ui);
  font-size: 15px;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
}

.number:hover {
  background: var(--gray-75);
}

.number[aria-current='page'] {
  background: var(--brand-navy);
  color: var(--white);
  font-weight: 500;
}

.number:disabled {
  cursor: not-allowed;
}

.number:disabled:not([aria-current='page']) {
  opacity: 0.55;
}

.gap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  color: var(--text-muted);
  font-size: 15px;
}

.arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  background: var(--white);
  color: var(--brand-navy);
  cursor: pointer;
}

.arrow:hover {
  border-color: var(--brand-navy);
}

.arrow:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.arrow:disabled:hover {
  border-color: var(--border-control);
}

.number:focus-visible,
.arrow:focus-visible,
.go:focus-visible,
.input:focus-visible {
  outline: none;
  border-color: var(--brand-cyan);
  box-shadow: var(--focus-halo);
}

.jump {
  grid-area: jump;
  justify-self: end;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
}

.jumpRow {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
  font-size: 13px;
  white-space: nowrap;
}

.go {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 0 12px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  background: var(--white);
  color: var(--brand-navy);
  font-family: var(--font-ui);
  font-size: 12px;
  letter-spacing: 0.08em;
  line-height: 1.1;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
}

.go:hover {
  border-color: var(--brand-navy);
}

.go:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.input {
  box-sizing: border-box;
  width: 68px;
  min-height: 44px;
  padding: 0 10px;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-sm);
  background: var(--white);
  color: var(--text-body);
  font-family: var(--font-body);
  font-size: 15px;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.input:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.bad {
  border-color: var(--status-problem-ink);
}

.error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 6px 0 0;
  color: var(--status-problem-ink);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

/* Arrows around an editable page number: shown only where the numbered row doesn't fit. */
.box {
  grid-area: box;
  display: none;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  white-space: nowrap;
}

.boxRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.box .input {
  width: 64px;
}

@container (max-width: 1080px) {
  .pager {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      'info info'
      'pages jump';
  }

  .pages {
    justify-self: start;
  }
}

@container (max-width: 700px) {
  .pager {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
      'info'
      'box';
  }

  .pages,
  .jump {
    display: none;
  }

  .box {
    display: flex;
  }
}
